import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=2bf979a7&"
import script from "./Grid.vue?vue&type=script&lang=js&"
export * from "./Grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gantt-elastic/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf979a7')) {
      api.createRecord('2bf979a7', component.options)
    } else {
      api.reload('2bf979a7', component.options)
    }
    module.hot.accept("./Grid.vue?vue&type=template&id=2bf979a7&", function () {
      api.rerender('2bf979a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chart/Grid.vue"
export default component.exports